import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../../assets/restaurant/meteri-logo-1.png"
import logo_back from "../../assets/admin/meteri_background_logo.svg"
import axios from "axios";

const AdminLogin = () => {
    const [data, setData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const role = localStorage.getItem("Role");
        const token = localStorage.getItem("token");

        if (role && token) {
            if (role === "admin") {
                navigate("/admin/dashboard");
            } else {
                console.error("Unrecognized role:", role);
            }
        } else {
            // console.error("User is not authenticated.");
        }
    }, [navigate]);

    const validateFields = () => {
        const newErrors = {};

        if (!data.email && !data.password) {
            const commonError = "Email and Password are required.";
            newErrors.email = commonError;
            newErrors.password = commonError;
            toast.error(commonError, {
                autoClose: 1000,
                theme: "colored",
            });
        } else {
            if (!data.email) {
                newErrors.email = "Email is required.";
                toast.error(newErrors.email, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }

            if (!data.password) {
                newErrors.password = "Password is required.";
                toast.error(newErrors.password, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateFields()) {
            console.log("Invalid data");
            return;
        }
        setIsLoading(true);

        const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
        const payload = {
            email: data.email,
            password: data.password,
            userType: "Admin"
        };

        try {
            const response = await axios.post(`${apiUrl}/api/v1/login`, payload);
            const resp = response?.data;
            // console.log(resp, "RESP");

            if (resp.token) {
                const { id: roleId, name: roleName, type: roleType } = resp?.entity?.role || {};
                const userType = resp?.loginUserType;
                const userId = resp?.loginUserId;

                const userName = resp?.entity?.name ? ` ${resp?.entity?.name}` : "";
                if (userType === "admin") {
                    localStorage.setItem("token", resp?.token);
                    localStorage.setItem("RoleName", roleName);
                    localStorage.setItem("RoleId", roleId);
                    localStorage.setItem("Role", roleType);
                    localStorage.setItem("loginUserId", userId);
                    localStorage.setItem("type", userType);
                    toast.success(`Welcome${userName}!`, {
                        autoClose: 1000,
                        theme: "colored",
                    });
                    navigate("/admin/dashboard");
                } else if (userType === "admin-user") {
                    localStorage.setItem("token", resp?.token);
                    localStorage.setItem("RoleName", roleName);
                    localStorage.setItem("RoleId", roleId);
                    localStorage.setItem("Role", roleType);
                    localStorage.setItem("loginUserId", userId);
                    localStorage.setItem("type", userType);
                    toast.success(`Welcome${userName}!`, {
                        autoClose: 1000,
                        theme: "colored",
                    });
                    navigate("/admin/dashboard");
                }
            }
        } catch (err) {
            if (err?.response?.data?.message) {
                console.log(err?.response?.data?.message);
                setData({ email: "", password: "" });
                toast.error(err?.response?.data?.message, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;

        if ((name === "password" && (value.length > 20 || /\s/.test(value))) ||
            (name === "email" && /\s/.test(value))) {
            return;
        }
        setData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));

    };

    return (
        <>
            <div className="bg-gray-100 flex flex-col min-h-screen">
                <header className="bg-transparent w-full p-4 flex justify-between items-center">
                    <Link to="/restaurant/spritz-and-co-srl">
                        <img src={logo} alt="Meteri Logo" className="h-12" />
                    </Link>
                    {/* <img src={logo} alt="Meteri Logo" className="h-12" /> */}
                </header>
                <div
                    className="flex bcklogo justify-center items-center flex-grow bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${logo_back})`,
                    }}
                >
                    <div className="w-full max-w-sm sm:max-w-md lg:max-w-md">
                        <div className="bg-[#a14c5b] text-white rounded-3xl shadow-lg p-8">
                            <h2 className="text-center text-2xl font-semibold mb-4 font-serif">
                                Login
                            </h2>
                            <p className="text-center text-gray-300 text-sm mb-4 poppins-regular">
                                Ciao! Inserisci i tuoi dati per accedere al tuo profilo
                            </p>

                            <form className="mx-3 font-mono" onSubmit={handleLogin}>
                                <div className="mb-4">
                                    <input
                                        className={`w-full px-4 py-3 text-xs rounded-3xl bg-transparent border focus:outline-none focus:border-gray-300 ${errors.email ? "border-red-500" : ""
                                            }`}
                                        type="text"
                                        name="email"
                                        placeholder="Email"
                                        value={data.email}
                                        onChange={handleOnChange}
                                    />
                                </div>

                                <div className="mb-2 relative">
                                    <input
                                        className={`w-full px-4 py-3 text-xs rounded-3xl bg-transparent border focus:outline-none focus:border-gray-300 ${errors.password ? "border-red-500" : ""
                                            }`}
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder="Password"
                                        value={data.password}
                                        onChange={handleOnChange}
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-4 text-gray-400 hover:text-gray-600 h-[42px]"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>

                                <div>
                                    <button
                                        className={`w-full py-2 px-4 rounded-3xl font-semibold transition duration-300 ${isLoading
                                            ? "bg-gray-300 text-gray-500"
                                            : "bg-white text-red-700 hover:bg-gray-100"
                                            }`}
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <div className="flex justify-center items-center">
                                                <span className="loader mr-2 border-t-2 border-white rounded-full w-4 h-4 animate-spin"></span>
                                                Logging In...
                                                {/* Ciao! Inserisci i tuoi dati per accedere al tuo profilo */}
                                            </div>
                                        ) : (
                                            "Login"
                                        )}
                                    </button>
                                </div>
                            </form>
                            <div className="text-center text-xs mt-3 poppins-regular">
                                <p>
                                    Copyright @Meteri 2024 | <a href="#">Privacy Policy</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLogin;